"use strict";
function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;
//# sourceMappingURL=_listCacheClear.js.map